import React, { useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  SelectChangeEvent,
} from "@mui/material";
import { IDdlist } from "../../app/types";
import { useAppSelector } from "../../app/hooks";
import { StyleUtils } from "../../app/utils/styleUtils";
import { setFieldValue } from "../MainContent/MainContentUtils";
import { showWarning } from "../../app/utils/validationUtils";

/* Functional component properties */
interface Props {
  classes: any;
  item: any;
  isGridElem: boolean;
  setWidth: string;
  clear: string;
  setClear: (clr: string) => void;
}

/* React Functional component */
export const Dropdown: React.FC<Props> = ({
  /* Function arguments (Props) */
  classes,
  item,
  isGridElem,
  setWidth,
  clear,
  setClear,
}): JSX.Element => {
  /* get state */
  const state = useAppSelector((state) => state);

  const [val, setVal] = useState(item.value ? item.value : "");

  useEffect(() => {
    if (item.value !== val) {
      setVal(item.value);
    }
  }, []);

  useEffect(() => {
    setFieldValue(item.name, val); // Set value in redux store
  }, [val]);

  useEffect(() => {
    if (
      clear === "true" &&
      item.editable &&
      item.editable === "true" &&
      val !== ""
    ) {
      setClear("false");
      setVal("");
    } else if (clear === "true") {
      setClear("false");
    }
  });

  function handleChange(event: SelectChangeEvent<string>) {
    if (isGridElem) {
      if (item.field.substr(0, 1) !== "F") {
        window.myGlobalVar.pendingChanges.status = true; // Set pending changes
        if (
          window.myGlobalVar.pendingChanges.items.indexOf(
            `${item.field + "(" + item.id + ")"}`
          ) === -1
        )
          window.myGlobalVar.pendingChanges.items.push(
            `${item.field + "(" + item.id + ")"}`
          );
        window.myGlobalVar.pendingChanges.showWarning = false;
      }
    } else {
      if (item.name.substr(0, 1) !== "F") {
        window.myGlobalVar.pendingChanges.status = true; // Set pending changes

        if (window.myGlobalVar.pendingChanges.items.indexOf(item.name) === -1)
          window.myGlobalVar.pendingChanges.items.push(item.name);
        window.myGlobalVar.pendingChanges.showWarning = false;
      }
    }

    setVal(event.target.value); // Set local state value in useState
    // setFieldValue(item.name, event.target.value); // Set value in redux store mainContent.fieldList
  }

  function getValue() {
    var ddlData: IDdlist | undefined = isGridElem
      ? state.mainContent.ddlist.find((ddlFld) => ddlFld.name === item.field)
      : state.mainContent.ddlist.find((ddlFld) => ddlFld.name === item.name);

    if (
      ddlData !== undefined &&
      ddlData!.elements.find((elem) => elem.code === item.value) != undefined
    ) {
      var element = ddlData!.elements.find((elem) => elem.code === item.value)!;

      switch (ddlData!.view) {
        case "code":
          return element.code;

        case "value":
          return element.value;

        case "code-value":
          return element.code + " - " + element.value;

        default:
          return val;
      }
    } else {
      return val;
    }
  }

  return isGridElem === true ? (
    item.colDef.canEdit && item.colDef.canEdit === true ? (
      <FormControl
        {...(showWarning(item.field, item.id) ? { color: "warning" } : {})} //Modified Fields
        {...(showWarning(item.field, item.id)
          ? { focussed: "true" }
          : { focussed: "false" })} //Modified Fields
        {...(item.editable && item.editable === "true"
          ? {}
          : { disabled: true })}
        className={
          item.visible && item.visible === "false" ? classes.hiddenField : ""
        }
        key={item.field + "(" + item.id + ")"}
        id={item.field + "(" + item.id + ")"}
        variant="outlined"
        style={
          setWidth === "true"
            ? {
                width: `${(() => StyleUtils.getWidth(item))()}px`, // Calculating width of the field
              }
            : {}
        }
        error={
          (state.mainContent.messageList.length > 0 &&
            state.mainContent.messageList.find(
              (msg) =>
                msg.fields !== undefined &&
                msg.fields?.indexOf(item.field + "(" + item.id + ")") >= 0
            ) !== undefined) ||
          showWarning(item.field, item.id)
        }
      >
        <InputLabel>{item.label}</InputLabel>
        <Select
          autoWidth={true}
          labelId={item.name}
          label={item.label}
          value={val}
          onChange={(e) => handleChange(e)}
          {...(showWarning(item.field, item.id)
            ? { focussed: "true" }
            : { focussed: "false" })} //Modified Fields
        >
          {state.mainContent.ddlist &&
          state.mainContent.ddlist.find(
            (ddlFld: IDdlist) => ddlFld.name === item.name
          ) !== undefined ? (
            state.mainContent.ddlist
              .find((ddlFld) => ddlFld.name === item.name)!
              .elements.map((elem) => (
                <MenuItem value={elem.code} key={elem.code}>
                  {(() => {
                    switch (
                      state.mainContent.ddlist.find(
                        (ddlFld) => ddlFld.name === item.name
                      )!.view
                    ) {
                      case "code":
                        return elem.code;

                      case "value":
                        return elem.value;

                      case "code-value":
                        return elem.code + " - " + elem.value;

                      default:
                        return val;
                    }
                  })()}
                </MenuItem>
              ))
          ) : (
            <MenuItem value={val} key={val}>
              {val}
            </MenuItem>
          )}
        </Select>
      </FormControl>
    ) : (
      getValue()
    )
  ) : (
    <FormControl
      // {...(showWarning(item.name) ? { color: "warning" } : {})} //Modified Fields
      // {...(showWarning(item.name)
      //   ? { focussed: "true" }
      //   : { focussed: "false" })} //Modified Fields{...(showWarning(item.name) ? { focussed: "true" } : {})} //Modified Fields
      {...(item.editable && item.editable === "true" ? {} : { disabled: true })}
      className={
        item.visible && item.visible === "false" ? classes.hiddenField : ""
      }
      key={item.name}
      id={item.name}
      variant="outlined"
      style={
        setWidth === "true"
          ? {
              width: `${(() => StyleUtils.getWidth(item))()}px`, // Calculating width of the field
            }
          : {}
      }
      error={
        (state.mainContent.messageList.length > 0 &&
          state.mainContent.messageList.find(
            (msg) =>
              msg.fields !== undefined && msg.fields?.indexOf(item.name) >= 0
          ) !== undefined) ||
        showWarning(item.name)
      }
      // helperText={
      //   state.mainContent.messageList.length > 0 &&
      //   state.mainContent.messageList.find(
      //     (msg) =>
      //       msg.fields !==undefined && msg.fields?.indexOf(item.name) >= 0
      //   ) !==undefined
      //     ? "Error"
      //     : ""
      // }
    >
      <InputLabel>{item.label}</InputLabel>
      <Select
        autoWidth={true}
        labelId={item.name}
        label={item.label}
        value={val}
        onChange={(e) => handleChange(e)}
      >
        {state.mainContent.ddlist &&
        state.mainContent.ddlist.find(
          (ddlFld: IDdlist) => ddlFld.name === item.name
        ) !== undefined ? (
          state.mainContent.ddlist
            .find((ddlFld) => ddlFld.name === item.name)!
            .elements.map((elem) => (
              <MenuItem value={elem.code} key={elem.code}>
                {(() => {
                  switch (
                    state.mainContent.ddlist.find(
                      (ddlFld) => ddlFld.name === item.name
                    )!.view
                  ) {
                    case "code":
                      return elem.code;

                    case "value":
                      return elem.value;

                    case "code-value":
                      return elem.code + " - " + elem.value;

                    default:
                      return val;
                  }
                })()}
              </MenuItem>
            ))
        ) : (
          <MenuItem value={val} key={val}>
            {val}
          </MenuItem>
        )}
      </Select>
      {state.mainContent.messageList.length > 0 &&
      state.mainContent.messageList.find(
        (msg) => msg.fields !== undefined && msg.fields?.indexOf(item.name) >= 0
      ) !== undefined ? (
        <FormHelperText>Error</FormHelperText>
      ) : (
        ""
      )}
    </FormControl>
  );
};
